import { useEffect, useState } from 'react'

import { useAppSelector } from 'reduxTyped'
import { getCurrentAccountID } from 'common/core/selectors/appSelectors'
import { localStorage } from 'utils'

const getSeenStorageKey = (accountId: string) =>
  `mc_wa_business_agent_automations_modal_seen_${accountId}`

interface UseBusinessAgentPausedModalReturn {
  isOpen: boolean
  open: () => void
  close: () => void
}

export const useBusinessAgentPausedModal = (
  isBusinessAgentEnabled: boolean | null,
): UseBusinessAgentPausedModalReturn => {
  const accountId = useAppSelector(getCurrentAccountID)
  const storageKey = getSeenStorageKey(accountId)

  const [isSeen, setIsSeen] = useState(() => localStorage.getItem(storageKey) !== undefined)
  const [isRequested, setIsRequested] = useState(false)

  // Turning the agent off forgets the dismissal, so the next time it is switched on counts as a
  // first visit again.
  useEffect(() => {
    if (isBusinessAgentEnabled === false) {
      localStorage.removeItem(storageKey)
      setIsSeen(false)
    }
  }, [isBusinessAgentEnabled, storageKey])

  const open = () => {
    setIsRequested(true)
  }

  const close = () => {
    localStorage.setItem(storageKey, String(Date.now()))
    setIsSeen(true)
    setIsRequested(false)
  }

  return {
    isOpen: isBusinessAgentEnabled === true && (isRequested || !isSeen),
    open,
    close,
  }
}
